<template>
    <div class="grid">
        <div class="col-12">
            <div class="card" v-if="permission?.includes('read')">
                <Toast />
                <Error :errors="errors" />

                <Fieldset legend="Add New" :toggleable="true" :collapsed="true" class="mb-3"
                    v-if="permission.includes('create')">
                    <Form @submit="getDataTable()" :type="'create'" ref="form" />
                </Fieldset>

                <DataTable v-model:expandedRows="expandedRows" @row-expand="onRowExpand" @row-collapse="onRowCollapse"
                    :value="dataTable" responsiveLayout="scroll" :loading="loading" dataKey="number"
                    @sort="onSort($event)" :resizableColumns="true">
                    <template #header>
                        <div class="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
                            <div>
                                <Button :loading="loadingExcel" label="Export Excel" icon="pi pi-file-excel"
                                    class="p-button p-button-success mr-2 my-1 inline-block"
                                    @click="exportExcelCSV('xlsx')" />
                                <Button :loading="loadingCsv" label="Export CSV" icon="pi pi-file-excel"
                                    class="p-button p-button-success mr-2 my-1 inline-block"
                                    @click="exportExcelCSV('csv')" />
                            </div>
                            <span class="block mt-2 md:mt-0 p-input-icon-left">
                                <i class="pi pi-search" />
                                <InputText v-model="search" placeholder="Cari..." @keyup.enter="getDataTable" />
                            </span>
                        </div>
                    </template>
                    <Column :expander="true" :headerStyle="{ 'width': '3rem' }" />
                    <Column field="number" header="No." :style="{ width: '20px' }">
                        <template #body="slotProps">
                            {{ slotProps.data.number }}
                        </template>
                    </Column>
                    <Column field="region_name" header="Region">
                        <template #body="slotProps">
                            {{ slotProps.data.region_name }}
                        </template>
                    </Column>
                    <Column field="ship_to_code" header="Ship to Code">
                        <template #body="slotProps">
                            {{ slotProps.data.ship_to_code }}
                        </template>
                    </Column>
                    <Column field="distributor_name" header="Distributor">
                        <template #body="slotProps">
                            {{ slotProps.data.distributor_name }}
                        </template>
                    </Column>
                    <Column field="city_name" header="City">
                        <template #body="slotProps">
                            {{ slotProps.data.city_name }}
                        </template>
                    </Column>
                    <Column field="lat" header="Latitude">
                        <template #body="slotProps">
                            {{ slotProps.data.lat }}
                        </template>
                    </Column>
                    <Column field="lng" header="Longitude">
                        <template #body="slotProps">
                            {{ slotProps.data.lng }}
                        </template>
                    </Column>
                    <Column field="gps_address" header="GPS Address">
                        <template #body="slotProps">
                            {{ slotProps.data.gps_address }}
                        </template>
                    </Column>

                    <Column field="status_distributor" header="Status">
                        <template #body="slotProps">
                            <Button icon="pi pi-check" class="p-button-rounded p-button-success"
                                v-if="slotProps.data.status_distributor == 'y'" />
                            <Button icon="pi pi-times" class="p-button-rounded p-button-danger" v-else />
                        </template>
                    </Column>

                    <Column header="Aksi" headerStyle="min-width:10rem;">
                        <template #body="slotProps">
                            <Button icon="pi pi-refresh" class="p-button-rounded p-button-danger mr-2"
                                @click="resetItem(slotProps.data)" v-if="permission.includes('update')" />
                            <Button icon="pi pi-pencil" class="p-button-rounded p-button-success mr-2"
                                @click="editItem(slotProps.data)" v-if="permission.includes('update')" />
                            <Button class="p-button-rounded p-button-info mr-2" @click="editUser(slotProps.data)"
                                v-if="permission.includes('update')">
                                Tambah User
                            </Button>
                        </template>
                    </Column>

                    <template #expansion="slotProps">
                        <DataTable :value="slotProps.data.user_details" class="dataTableDetail"
                            responsiveLayout="scroll">
                            <Column field="username" header="Username">
                                <template #body="detailProps">
                                    {{ detailProps.data.username }}
                                </template>
                            </Column>
                            <Column field="name" header="Name">
                                <template #body="detailProps">
                                    {{ detailProps.data.name }}
                                </template>
                            </Column>
                            <Column field="status_user_distributor" header="Status">
                                <template #body="detailProps">
                                    <Button icon="pi pi-check" class="p-button-rounded p-button-success"
                                        v-if="detailProps.data.status_user_distributor == 'y'" />
                                    <Button icon="pi pi-times" class="p-button-rounded p-button-danger" v-else />
                                </template>
                            </Column>
                            <Column header="Aksi" field="aksi">
                                <template #body="detailProps">
                                    <Button v-if="permission.includes('update')"
                                        @click="editStatus(slotProps.data, detailProps.data)"
                                        class="p-button-rounded p-button-info mr-2">Edit Status</Button>
                                </template>
                            </Column>
                        </DataTable>
                    </template>

                    <template #empty> No data found. </template>
                    <template #loading> Loading data. Please wait. </template>
                    <template #footer>
                        In total there are {{ totalItemsCount ? totalItemsCount : 0 }} data.
                    </template>
                </DataTable>

                <Paginator v-model:rows="rows" v-model:first="offset" :totalRecords="totalItemsCount"
                    :rowsPerPageOptions="[10, 20, 30]">
                    <template>
                        {{ totalItemsCount }}
                    </template>
                </Paginator>

                <Reset @submit="getDataTable()" :item="item" ref="reset" />

                <Dialog v-model:visible="editStatusDialog" :style="{ width: '450px' }" header="Edit Status"
                    :modal="true" class="p-fluid">

                    <div class="field">
                        <label>Status</label>
                        <Dropdown ref="dstatus" v-model="itemUser.status_user_distributor" :options="dataDropdownStatus"
                            :class="{ 'p-invalid': errorEdit.status }" optionLabel="name" optionValue="code"
                            placeholder="Pilih Status" :showClear="true" />
                        <small class="p-invalid" style="color: red" v-if="errorEdit.status">{{ errorEdit.status[0]
                            }}</small>
                    </div>
                    <template #footer>
                        <Button label="Batal" icon="pi pi-times" class="p-button-text" @click="hideDialogStatus" />
                        <Button label="Simpan" icon="pi pi-check" class="p-button-text" @click="updateStatus"
                            :loading="loadingEditStatus" />
                    </template>
                </Dialog>

                <Dialog v-model:visible="editItemDialog" :style="{ maxWidth: '1200px', width: '100%' }"
                    header="Data Detail" :modal="true" class="p-fluid">
                    <Form @submit="getDataTable()" @cancel="hideDialog" @close="editItemDialog = false" :item="itemEdit"
                        :type="'edit'" ref="form" />
                </Dialog>

                <Dialog v-model:visible="addUserDialog" :style="{ maxWidth: '1200px', width: '100%' }"
                    :header="'Data Tambah User ' + itemEdit.distributor_name" :modal="true" class="p-fluid">
                    <FormUser @submit="getDataTable()" @cancel="hideDialog" @close="addUserDialog = false"
                        :item="itemEdit" ref="formUser" />
                </Dialog>
            </div>
        </div>
    </div>
</template>

<style>
.dataTableDetail table {
    min-width: 0 !important;
}
</style>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import { numberingDatatable } from "../../utils/helpers";
import Error from "../../components/Error.vue";
import Reset from "../../components/master/distributor/Reset.vue";
import Form from '../../components/master/distributor/Form.vue';
import FormUser from "../../components/master/distributor/FormUser.vue";

export default {
    components: {
        Error: Error,
        Reset: Reset,
        Form: Form,
        FormUser: FormUser,
    },
    data() {
        return {
            // loading
            loading: false,
            loadingExcel: false,
            loadingCsv: false,
            loadingEditStatus: false,

            //datatables
            data: null,
            dataTable: null,
            rows: 10,
            search: null,
            offset: null,
            field: null,
            sort: null,
            page: null,
            totalItemsCount: 0,
            expandedRows: [],

            // dataDropdown
            dataDropdownStatus: [
                { name: 'Aktif', code: 'y' },
                { name: 'Nonaktif', code: 'n' },
            ],

            //edit
            editStatusDialog: false,
            editItemDialog: false,
            addUserDialog: false,
            item: {},
            itemEdit: {},
            itemUser: {},

        };
    },
    mounted() {
        this.getDataTable();
        this.$store.commit("setErrors", {});
    },
    watch: {
        offset() {
            this.getDataTable();
        },
        rows() {
            this.getDataTable();
        },
    },
    computed: {
        ...mapGetters(['errors', 'errorEdit', 'errorAdd']),
        ...mapGetters("auth", ["permission"]),
    },
    methods: {
        onRowExpand(event) {
            console.log('Row expanded:', event.data);
        },
        onRowCollapse(event) {
            console.log('Row collapsed:', event.data);
        },
        formatDate(value) {
            if (value) {
                return moment.utc(value).format("DD-MM-YYYY");
            }
        },
        // DATATABLE
        getDataTable() {
            this.loading = true;
            if (this.$refs?.filter) {
                this.$refs.filter.loading = true;
            }
            this.page = this.offset / this.rows + 1;

            this.axios({
                method: "GET",
                url: process.env.VUE_APP_ROOT_API + "web/master-distributor",
                params: {
                    search: this.search,
                    per_page: this.rows,
                    page: this.page,
                    order_by: this.field,
                    sort_by: this.sort
                },
            })
                .then((res) => {
                    this.data = res.data.data.data;
                    this.dataTable = numberingDatatable(
                        res.data.data.data,
                        this.page,
                        this.rows
                    );
                    this.totalItemsCount = res.data.data.total;
                    this.rows = parseInt(res.data.data.per_page);
                    this.loading = false;
                    if (this.$refs?.filter) {
                        this.$refs.filter.loading = false;
                    }
                })
                .catch((err) => {
                    console.log(err);
                    this.loading = false;
                    if (this.$refs?.filter) {
                        this.$refs.filter.loading = false;
                    }
                });
        },
        onSort(event) {
            this.field = event.sortField;
            this.sort = event.sortOrder == "1" ? "ASC" : "DESC";
            this.getDataTable();
        },
        // EXPORT
        exportExcelCSV(ext) {
            if (ext == "xlsx") {
                this.loadingExcel = true;
            } else if (ext == "csv") {
                this.loadingCsv = true;
            }

            this.axios({
                method: "GET",
                url: process.env.VUE_APP_ROOT_API + "web/master-distributor/export",
                responseType: "blob",
                params: {
                    ext: ext,
                },
            })
                .then((response) => {
                    let fileUrl = window.URL.createObjectURL(response.data);
                    let fileLink = document.createElement("a");

                    fileLink.href = fileUrl;

                    fileLink.setAttribute("download", "Master Distributor Export." + ext);

                    document.body.appendChild(fileLink);

                    fileLink.click();

                    if (ext == "xlsx") {
                        this.loadingExcel = false;
                    } else if (ext == "csv") {
                        this.loadingCsv = false;
                    }
                })
                .catch((err) => {
                    console.log(err);

                    if (ext == "xlsx") {
                        this.loadingExcel = false;
                    } else if (ext == "csv") {
                        this.loadingCsv = false;
                    }
                });
        },

        // RESET
        resetItem(item) {
            this.item = item;

            this.$refs.reset.resetItemDialog = true;
        },

        // EDIT
        editUser(item) {
            this.itemEdit = {
                ...item,
            };

            this.addUserDialog = true;
            this.$store.commit('setErrorEdit', {});

        },
        editItem(item) {
            this.itemEdit = {
                ...item,
                latitude: item.lat,
                longitude: item.lng
            };

            this.editItemDialog = true;
            this.$store.commit('setErrorEdit', {});

        },
        hideDialog() {
            this.editItemDialog = false;
            this.addUserDialog = false;
            this.submitted = false;
        },
        editStatus(item, itemUser) {
            this.item = item;
            this.itemUser = itemUser;

            this.editStatusDialog = true;
            this.$store.commit('setErrorEdit', {});

        },
        hideDialogStatus() {
            this.editStatusDialog = false;
            this.submitted = false;
        },
        updateStatus() {
            this.loadingEditStatus = true;

            this.axios({
                method: 'POST',
                url: process.env.VUE_APP_ROOT_API + 'web/master-distributor/update-status',
                data: {
                    "distributor_id": this.item.distributor_id,
                    "status": this.itemUser.status_user_distributor,
                    "mcu_id": this.itemUser.mcu_id
                },
            })
                .then((res) => {
                    this.loadingEditStatus = false;
                    if (res) {
                        this.$toast.add({ severity: 'success', summary: 'Successful', detail: 'Data Berhasil Diupdate', life: 3000, });
                        this.$store.commit('setErrors', {});
                        this.$store.commit('setErrorEdit', {});
                        this.item = {};
                        this.editStatusDialog = false;
                        this.getDataTable();
                    }
                })
                .catch((err) => {
                    console.log(err);
                    this.loadingEditStatus = false;
                    this.$store.commit('setErrorEdit', err.response.data.data);
                    this.$toast.add({ severity: 'error', summary: 'Failed', detail: 'Data Gagal Diperbarui', life: 3000, });
                });
        },
    },
};
</script>
